<template>
  <div>
     <vue-element-loading :active="appLoading" :is-full-screen="true"/>
    <v-layout wrap>
      <v-flex xs12>
        <v-card tile flat>
          <v-carousel
            height="100vh"
            cycle
            hide-delimiter-background
            show-arrows-on-hover
          >
            <v-carousel-item
              v-for="(item, i) in sliders"
              :key="i"
              alt="Image couldnt load"
              :src="baseURL + item.image"
              gradient="to bottom, rgba(0,0,0,.4), rgba(0,0,0,.5)"
              style="opacity: 1"
            >
              <v-row class="fill-height pa-3" align="center" justify="center">
                <div class="overlayShade">
                  <span style="font-size: 35px;color:#0B0448!important; font-family: poppinssemibold">{{
                    item.text
                  }}</span>
                </div>
              </v-row>
            </v-carousel-item>
          </v-carousel>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      sliders: [],
      appLoading:false,
    };
  },
  mounted: function () {
    this.getSliders();
  },
  methods: {
    getSliders() {
          this.appLoading=true

      axios({
        method: "GET",
        url: "/homepage/slider/list",
      })
        .then((response) => {
          if(response.data.status)
          {
          this.sliders = response.data.data;
          this.appLoading=false
          }
          else
          this.appLoading=false

        })
        .catch(() => {
          this.appLoading=false

        });
    },
  },
};
</script>
<style scoped>
.overlayShade {
  background-color: rgba(185, 182, 182, 0.5);
}
</style>